export default {
  created() {
    this.setPageTitle()
  },
  methods: {
    setPageTitle() {
      const {title} = this.$options
      if (title) {
        document.title = 'My-CoolPay Admin - ' + (
          typeof title === 'function'
            ? title.call(this)
            : title
        )
      }
    }
  }
}
